<script setup>
import { Head, usePage,Link } from '@inertiajs/vue3'
import moment from 'moment';
import axios from 'axios';

const page = usePage();
const user = page.props.auth.user;
const props = defineProps({
    order: Object,
})

function downloadInvoice() {
    window.open('/portal/facturen/' + props.order.id + '/download', '_blank');
}

function sendInvoice() {
    axios.post('/portal/facturen/' + props.order.id + '/send').then(() => {
        page.props.order.invoice_sent = true;
    });
}
</script>

<template>
    <Head title="Factuur bekijken | Mijnautosnelweg" />
    <form class="px-4 sm:px-6 py-6" @submit.prevent="submit">
        <div class="grid grid-cols-1  mx-auto max-w-6xl gap-8 px-4 sm:px-6 py-6">
            <div class="lg:col-span-4 flex flex-col gap-8">
                <div class="ring-1 rounded-lg p-4 flex flex-col gap-4">
                    <div class="flex flex-row justify-between">
                        <h3 class="text-xl font-medium leading-6 text-gray-900">Factuur #{{order.id}}</h3>
                    </div>
                    <div class="flex flex-row items-center gap-4 text-sm">
                        <div v-if="order.status === 'paid'"
                            class="text-green-700 bg-green-50 ring-green-600/20 rounded-full px-3.5 py-1.5 text-sm font-medium ring-1 ring-inset">
                            Voldaan</div>
                        <div v-if="order.status === 'pending'"
                            class="text-gray-600 bg-gray-50 ring-gray-500/10 rounded-full px-3.5 py-1.5 text-sm font-medium ring-1 ring-inset">
                            Open</div>
                        <div v-if="order.status === 'overdue'"
                            class="text-red-700 bg-red-50 ring-red-600/10 rounded-full px-3.5 py-1.5 text-sm font-medium ring-1 ring-inset">
                            Te laat</div>
                        <p class="text-gray-900 font-light text-sm">{{moment(order.created_at).format('DD-MM-YYYY')}}</p>
                    </div>
                    <div class="flex flex-row items-center gap-4 text-sm" v-if="!user.dealer">
                        <button type="button" v-if="!order.invoice_sent" @click="sendInvoice"
                            class="w-full rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
                            Factuur verzenden</button>
                        <Link :href="'/portal/facturen/'+order.id+'/edit'"
                            class="w-full text-center rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
                            Factuur aanpassen</Link>
                    </div>
                    <div v-else class="flex flex-row items-center gap-4 text-sm">
                        <a v-if="order.status !== 'paid'" :href="order.payment_url"
                            class="w-full rounded-md bg-brightorange text-center hover:cursor-pointer text-white hover border px-3.5 py-2.5 text-sm font-semibold shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
                            Factuur betalen</a>
                    </div>
                </div>
                
            </div>
            <div class="lg:col-span-2 flex flex-col gap-8">
                <div class="ring-1 rounded-lg p-6 flex flex-col gap-4">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Details</h3>
                    <div class="flex flex-col my-4 gap-2">
                        <div class="flex flex-row mt-4 items-center gap-4 text-sm">
                            <font-awesome-icon :icon="['fal', 'circle-user']" class="h-5 w-5 text-gray-900 shrink-0" />
                            <!-- Naam aan wie dit gefactureerd is -->
                            <p class="text-gray-900">mijnautosnelweg</p>
                        </div>
                        <div class="flex flex-row mt-4 items-center gap-4 text-sm">
                            <font-awesome-icon :icon="['fal', 'envelope']" class="h-5 w-5 text-gray-900 shrink-0" />
                            <!-- E-mail van gefactureerde -->
                            <p class="text-gray-900">info@mijnautosnelweg.nl</p>
                        </div>
                        <div class="flex flex-row mt-4 items-center gap-4 text-sm">
                            <font-awesome-icon :icon="['fal', 'calendar-day']" class="h-5 w-5 text-gray-900 shrink-0" />
                            <!-- Facturatie datum en tijd -->
                            <p class="text-gray-900">{{moment(order.created_at).format('DD-MM-YYYY')}}</p>
                        </div>
                        <div class="flex flex-row mt-4 items-center gap-4 text-sm">
                            <font-awesome-icon :icon="['fal', 'file-invoice']" class="h-5 w-5 text-gray-900 shrink-0" />
                            <!-- Factuurnummer -->
                            <p class="text-gray-900">{{order.id}}</p>
                        </div>
                    </div>
                    <button type="button" @click="downloadInvoice"
                        class="w-full rounded-md bg-royalblue-500 border px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-royalblue-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
                        Factuur PDF</button>
                </div>
                <div class="ring-1 rounded-lg p-4 flex flex-col">
                    <div class="flex flex-row my-4 gap-2">
                        <div
                            class="flex h-10 w-10 items-center justify-center rounded-full bg-royalblue-500 ring-8 ring-white">
                            <font-awesome-icon :icon="['fal', 'circle-question']" class="h-5 w-5 text-white shrink-0" />
                        </div>
                        <h3 class="text-xl font-medium leading-6 text-gray-900 mt-4">Vragen?</h3>
                    </div>
                    <p class="text-sm text-gray-700 my-4">Vragen over je factuur of ondervind je problemen? Neem dan
                        contact met ons op.</p>
                </div>
            </div>
        </div>
    </form>
</template>